/* eslint-disable react/no-unknown-property */
/* eslint-disable react/require-default-props */
import React from 'react';

interface DialerMicrophoneProps {
  width?: number;
  height?: number;
  className?: string;
}

// ENABLE MICROPHONE SVG
export const DialerMicrophoneEnable: React.FC<DialerMicrophoneProps> = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99968 2.49382C9.0792 2.49382 8.33301 3.24001 8.33301 4.16048V8.32715C8.33301 9.24762 9.0792 9.99382 9.99968 9.99382C10.9201 9.99382 11.6663 9.24762 11.6663 8.32715V4.16048C11.6663 3.24001 10.9201 2.49382 9.99968 2.49382ZM6.66634 4.16048C6.66634 2.31953 8.15873 0.827148 9.99968 0.827148C11.8406 0.827148 13.333 2.31953 13.333 4.16048V8.32715C13.333 10.1681 11.8406 11.6605 9.99968 11.6605C8.15873 11.6605 6.66634 10.1681 6.66634 8.32715V4.16048Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16634 7.50629C4.62658 7.50629 4.99967 7.87939 4.99967 8.33963C4.99967 9.66571 5.52646 10.9375 6.46414 11.8752C7.40182 12.8128 8.67359 13.3396 9.99968 13.3396C11.3258 13.3396 12.5975 12.8128 13.5352 11.8752C14.4729 10.9375 14.9997 9.66571 14.9997 8.33963C14.9997 7.87939 15.3728 7.50629 15.833 7.50629C16.2932 7.50629 16.6663 7.87939 16.6663 8.33963C16.6663 10.1077 15.964 11.8034 14.7137 13.0537C13.4635 14.3039 11.7678 15.0063 9.99968 15.0063C8.23157 15.0063 6.53587 14.3039 5.28563 13.0537C4.03539 11.8034 3.33301 10.1077 3.33301 8.33963C3.33301 7.87939 3.7061 7.50629 4.16634 7.50629Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83301 17.5001C5.83301 17.0398 6.2061 16.6667 6.66634 16.6667H13.333C13.7932 16.6667 14.1663 17.0398 14.1663 17.5001C14.1663 17.9603 13.7932 18.3334 13.333 18.3334H6.66634C6.2061 18.3334 5.83301 17.9603 5.83301 17.5001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99968 13.3272C10.4599 13.3272 10.833 13.7002 10.833 14.1605V17.4938C10.833 17.9541 10.4599 18.3272 9.99968 18.3272C9.53944 18.3272 9.16634 17.9541 9.16634 17.4938V14.1605C9.16634 13.7002 9.53944 13.3272 9.99968 13.3272Z"
      fill="currentColor"
    />
  </svg>
);

// ACTIVE MICROPHONE SVG
export const DialerMicrophoneActive: React.FC<DialerMicrophoneProps> = ({
  width = 42,
  height = 42,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="22" fill="#F3F4F6" />
    <g clipPath="url(#clip0_36937_534212)">
      <path
        d="M14.5 14.5L29.5 29.5"
        stroke="#383838"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 16.1666C19.5 15.5036 19.7634 14.8677 20.2322 14.3989C20.7011 13.93 21.337 13.6666 22 13.6666C22.663 13.6666 23.2989 13.93 23.7678 14.3989C24.2366 14.8677 24.5 15.5036 24.5 16.1666V20.3333C24.5 20.5801 24.4635 20.8255 24.3917 21.0616M22.725 22.7283C22.3514 22.8415 21.9565 22.8656 21.5719 22.7988C21.1872 22.7319 20.8236 22.5759 20.5101 22.3433C20.1967 22.1107 19.942 21.8078 19.7666 21.4591C19.5912 21.1103 19.4999 20.7253 19.5 20.335V19.5016"
        stroke="#383838"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.167 20.3334C16.1668 21.3862 16.4515 22.4194 16.991 23.3234C17.5305 24.2275 18.3045 24.9687 19.2311 25.4685C20.1577 25.9683 21.2023 26.208 22.2541 26.1622C23.3059 26.1164 24.3257 25.7868 25.2053 25.2084M26.872 23.5417C27.5002 22.5898 27.8341 21.4739 27.832 20.3334"
        stroke="#383838"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.667 29.5H25.3337"
        stroke="#383838"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 26.1666V29.5"
        stroke="#383838"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_36937_534212">
        <rect
          width={width}
          height={height}
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
);
